import ExponentGyroscope from './ExponentGyroscope';
import ThreeAxisSensor from './ThreeAxisSensor';

export default new ThreeAxisSensor(ExponentGyroscope, 'gyroscopeDidUpdate');
